import axios from 'axios'; // 引入axios
import QS from 'qs'; // 引入qs模块，用来序列化post类型的数据，后面会提到
import {
	getLodop
} from '../utils/LodopFuncs'



/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
	return new Promise((resolve, reject) => {
		axios.get(url, {
			params: params
		}).then(res => {
			resolve(res.data);
		}).catch(err => {
			reject(err.data)
		})
	});
}
/** 
 * post方法，对应post请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function post(url, params) {
	// 过滤空字符串
	var par = {};
	for (var p in params) {
		//var p; // 属性名name 
		//var params[p]; //属性值gao
		if (params[p] != undefined && params[p] != '') {
			par[p] = params[p];
		}
	}

	return new Promise((resolve, reject) => {
		// axios.hea
		axios.post(url, par).then(res => {
			resolve(res.data);
		})
			.catch(err => {
				reject(err.data)
			})
	});
}

/** 
 * post方法，对应post请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function postHeader(url, params, headers) {
	return new Promise((resolve, reject) => {
		// axios.hea
		axios.post(url, params, {
			headers: headers
		}).then(res => {
			resolve(res.data);
		})
			.catch(err => {
				reject(err.data)
			})
	});
}

/** 
 * post方法，对应post请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function postQuery(url, params) {
	return new Promise((resolve, reject) => {
		// axios.hea
		axios.post(url, {}, {
			params: params
		}).then(res => {
			resolve(res.data);
		})
			.catch(err => {
				reject(err.data)
			})
	});
}

/**
 * 打印操作证书 - 第一个种类
 * @param {Object} params
 */
export function printCertificateFirst(params) {
	console.log(params)
	let LODOP = getLodop();

	// 获取默认打印机
	LODOP.SET_PRINTER_INDEX(-1);

	// 打印图片  ADD_PRINT_IMAGE和SET_PRINT_STYLEA函数可以缩放打印图片
	/* LODOP.ADD_PRINT_IMAGE(179,237,81,100,"<img border='0' src='"+params.ownerCredentialsPhoto2+"' />");
	LODOP.SET_PRINT_STYLEA(0,"Stretch",2);//按原图比例(不变形)缩放模式 */


	// 培训起止日期：开始
	var studyDateStartArr = [];
	var studyDateStart = params.studyDateStart;
	if (studyDateStart != undefined && studyDateStart != '') {
		studyDateStartArr = studyDateStart.split("-");
	} else {
		studyDateStartArr.push("-");
		studyDateStartArr.push("-");
		studyDateStartArr.push("-");
	}

	// 培训起止日期：截止
	var studyDateEndArr = [];
	var studyDateEnd = params.studyDateEnd;
	if (studyDateEnd != undefined && studyDateEnd != '') {
		studyDateEndArr = studyDateEnd.split("-");
	} else {
		studyDateEndArr.push("-");
		studyDateEndArr.push("-");
		studyDateEndArr.push("-");
	}

	// 审核时间字符串
	var auditTimeStrArr = [];
	var auditTimeStr = params.validDateStart;
	if (auditTimeStr != undefined && auditTimeStr != '') {
		auditTimeStrArr = auditTimeStr.split("-");
	} else {
		auditTimeStrArr.push("-");
		auditTimeStrArr.push("-");
		auditTimeStrArr.push("-");
	}

	// 有效起止日期：截止
	var validDateEndArr = [];
	var validDateEnd = params.validDateEnd;
	if (validDateEnd != undefined && validDateEnd != '') {
		validDateEndArr = validDateEnd.split("-");
	} else {
		validDateEndArr.push("-");
		validDateEndArr.push("-");
		validDateEndArr.push("-");
	}
	console.log(params)
	console.log(validDateEndArr)

	// 打印初始化
	LODOP.PRINT_INIT("打印任务名");
	LODOP.SET_PRINT_PAGESIZE(1, "188mm", "133mm", ""); //设置纸张高度
	LODOP.SET_SHOW_MODE("BKIMG_WIDTH", "188mm");
	LODOP.SET_SHOW_MODE("BKIMG_HEIGHT", "133mm");

	/* 
	LODOP.ADD_PRINT_TEXT("23mm","50mm","50mm","7mm",params.ownerName);
	LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
	LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
	 */

	// params.ownerName   
	LODOP.ADD_PRINT_TEXT("81mm", "39mm", "50mm", "7mm", params.ownerName);
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
	LODOP.ADD_PRINT_TEXT("89mm", "39mm", "50mm", "7mm", params.ownerSexStr);
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
	LODOP.ADD_PRINT_TEXT("97mm", "39mm", "50mm", "7mm", params.ownerEducationDegree);
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
	LODOP.ADD_PRINT_TEXT("106mm", "39mm", "50mm", "7mm", params.ownerIdentityCards); // 身份证号
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
	LODOP.ADD_PRINT_TEXT("9mm", "133mm", "50mm", "7mm", params.operationCertificateNumber); // 证书编号
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
	LODOP.ADD_PRINT_TEXT("23mm", "120mm", "40mm", "7mm", params.ownerName);
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
	LODOP.ADD_PRINT_TEXT("23mm", "158mm", "30mm", "7mm", studyDateStartArr[0]); //"年"
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
	LODOP.ADD_PRINT_TEXT("30mm", "107mm", "20mm", "7mm", studyDateStartArr[1]); //"月"
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
	LODOP.ADD_PRINT_TEXT("30mm", "118mm", "20mm", "7mm", studyDateStartArr[2]); //"日"
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
	LODOP.ADD_PRINT_TEXT("30mm", "136mm", "20mm", "7mm", studyDateEndArr[0]); // "年"
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
	LODOP.ADD_PRINT_TEXT("30mm", "151mm", "20mm", "7mm", studyDateEndArr[1]); // "月"
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
	LODOP.ADD_PRINT_TEXT("30mm", "163mm", "20mm", "7mm", studyDateEndArr[2]); //"日"
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
	LODOP.ADD_PRINT_TEXT("36mm", "140mm", "50mm", "7mm", params.operationItems); // 操作项目
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
	//LODOP.ADD_PRINT_TEXT(360,564,100,20,"发证单位");
	LODOP.ADD_PRINT_TEXT("82mm", "141mm", "10mm", "7mm", auditTimeStrArr[0]); //"年"
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
	LODOP.ADD_PRINT_TEXT("82mm", "153mm", "10mm", "7mm", auditTimeStrArr[1]); //"月"
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
	LODOP.ADD_PRINT_TEXT("82mm", "161mm", "10mm", "7mm", auditTimeStrArr[2]); //"日"
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
	LODOP.ADD_PRINT_TEXT("99mm", "135mm", "10mm", "7mm", validDateEndArr[0]); //"年"
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
	LODOP.ADD_PRINT_TEXT("99mm", "149mm", "10mm", "7mm", validDateEndArr[1]); //"月"
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
	LODOP.ADD_PRINT_TEXT("99mm", "158mm", "10mm", "7mm", validDateEndArr[2]); //"日"
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);

	// 打印预览
	LODOP.PREVIEW();
	//PRINT_SETUP打印维护
	// PRINT直接打印
	//LODOP.PRINT();   
	// PRINT_DESIGN打印设计
	//LODOP.PRINT_DESIGN();
}

/**
 * 打印操作证书 - 第二个种类 - 目前作废
 * @param {Object} params
 */
export function printCertificateSecond(params) {

	let LODOP = getLodop();

	// 获取默认打印机
	LODOP.SET_PRINTER_INDEX(-1);

	// 打印初始化
	LODOP.PRINT_INIT("打印任务名");

	// 有效起止日期：开始
	var validDateStartArr = [];
	var validDateStart = params.validDateStart;
	if (validDateStart != undefined && validDateStart != '') {
		validDateStartArr = validDateStart.split("-");
		var year = validDateStartArr[0];
		validDateStartArr[0] = year.substr(2, 2);
	} else {
		validDateStartArr.push("-");
		validDateStartArr.push("-");
		validDateStartArr.push("-");
	}

	// 有效起止日期：截止
	var validDateEndArr = [];
	var validDateEnd = params.validDateEnd;
	if (validDateEnd != undefined && validDateEnd != '') {
		validDateEndArr = validDateEnd.split("-");
		var year = validDateEndArr[0];
		validDateEndArr[0] = year.substr(2, 2);
	} else {
		validDateEndArr.push("-");
		validDateEndArr.push("-");
		validDateEndArr.push("-");
	}

	//LODOP.ADD_PRINT_SETUP_BKIMG("C:\\Users\\Administrator\\Desktop\\证书22.jpg");
	LODOP.ADD_PRINT_TEXT(104, 172, 100, 20, params.operationCertificateNumber);
	LODOP.ADD_PRINT_TEXT(132, 175, 100, 20, params.ownerName);
	LODOP.ADD_PRINT_TEXT(156, 176, 100, 20, params.ownerIdentityCards);
	LODOP.ADD_PRINT_TEXT(178, 175, 100, 20, params.operationItems);
	LODOP.ADD_PRINT_TEXT(201, 188, 23, 20, validDateStartArr[0]); //"年"
	LODOP.ADD_PRINT_TEXT(201, 215, 23, 20, validDateStartArr[1]); //"月"
	LODOP.ADD_PRINT_TEXT(201, 253, 26, 20, validDateStartArr[2]); //"日"
	LODOP.ADD_PRINT_TEXT(201, 308, 21, 20, validDateEndArr[0]); //"年"
	LODOP.ADD_PRINT_TEXT(201, 339, 23, 20, validDateEndArr[1]); //"月"
	LODOP.ADD_PRINT_TEXT(201, 380, 22, 20, validDateEndArr[2]); //"日"

	if (params.isFirst != undefined && params.isFirst == 2) {
		LODOP.ADD_PRINT_TEXT(226, 300, 23, 20, 1); // 换发
	} else {
		LODOP.ADD_PRINT_TEXT(226, 188, 23, 20, 1); // 初次颁发
	}

	LODOP.ADD_PRINT_TEXT(226, 357, 37, 20, params.workAge); //"岗龄"

	// 打印预览
	LODOP.PREVIEW();
	//PRINT_SETUP打印维护
	// PRINT直接打印
	//LODOP.PRINT();   
	// PRINT_DESIGN打印设计


}
/**
 * 打印操作证书 - 正副本
 * @param {Object} params
 */
export function printCertificateZhengfuben(params) {
	console.log(params)
	let LODOP = getLodop();

	// 获取默认打印机
	LODOP.SET_PRINTER_INDEX(-1);

	// 打印初始化
	LODOP.PRINT_INIT("打印操作证书");
	LODOP.SET_PRINT_PAGESIZE(1, "88mm", "122mm", ""); //设置纸张高度
	LODOP.SET_SHOW_MODE("BKIMG_WIDTH", "88mm");
	LODOP.SET_SHOW_MODE("BKIMG_HEIGHT", "122mm");




	// 有效起止日期：开始
	var validDateStartArr = [];
	var validDateStart = params.validDateStart;
	if (validDateStart != undefined && validDateStart != '') {
		validDateStartArr = validDateStart.split("-");
		var year = validDateStartArr[0];
		validDateStartArr[0] = year.substr(2, 2);
	} else {
		validDateStartArr.push("-");
		validDateStartArr.push("-");
		validDateStartArr.push("-");
	}

	// 有效起止日期：截止
	var validDateEndArr = [];
	var validDateEnd = params.validDateEnd;
	if (validDateEnd != undefined && validDateEnd != '') {
		validDateEndArr = validDateEnd.split("-");
		var year = validDateEndArr[0];
		validDateEndArr[0] = year.substr(2, 2);
	} else {
		validDateEndArr.push("-");
		validDateEndArr.push("-");
		validDateEndArr.push("-");
	}


	/* 
	LODOP.ADD_PRINT_TEXT("86mm","157mm","10mm","7mm",auditTimeStrArr[1]);//"月"
	
	 */

	LODOP.ADD_PRINT_TEXT("16mm", "24mm", "50mm", "7mm", params.operationCertificateNumber); // 操作证编号
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
	LODOP.ADD_PRINT_TEXT("22mm", "24mm", "50mm", "7mm", params.ownerName); // 姓名
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
	LODOP.ADD_PRINT_TEXT("28mm", "24mm", "50mm", "7mm", params.ownerIdentityCards); // 身份证号
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
	LODOP.ADD_PRINT_TEXT("33mm", "24mm", "50mm", "7mm", params.operationItems); // 操作项目
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
	LODOP.ADD_PRINT_TEXT("39mm", "25mm", "10mm", "7mm", validDateStartArr[0]); //"年"  使用期限
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
	LODOP.ADD_PRINT_TEXT("39mm", "33mm", "10mm", "7mm", validDateStartArr[1]); //"月"
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
	LODOP.ADD_PRINT_TEXT("39mm", "41mm", "10mm", "7mm", validDateStartArr[2]); //"日"
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
	LODOP.ADD_PRINT_TEXT("39mm", "54mm", "10mm", "7mm", validDateEndArr[0]); //"年"
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
	LODOP.ADD_PRINT_TEXT("39mm", "62mm", "10mm", "7mm", validDateEndArr[1]); //"月"
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
	LODOP.ADD_PRINT_TEXT("39mm", "69.5mm", "10mm", "7mm", validDateEndArr[2]); //"日"
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);

	if (params.isFirst != undefined && params.isFirst == 2) {
		//LODOP.ADD_PRINT_TEXT("47mm","50mm","10mm","7mm",1);// 换发
		// LODOP.ADD_PRINT_LINE("49mm", "46mm", "46mm", "48mm", 0, 1);
		// LODOP.ADD_PRINT_LINE("46mm", "44mm", "49mm", "46mm", 0, 1);
		LODOP.ADD_PRINT_LINE("48mm", "50mm", "46mm", "52mm", 0, 1);
		LODOP.ADD_PRINT_LINE("45mm", "48mm", "49mm", "50mm", 0, 1);
	} else {
		//LODOP.ADD_PRINT_TEXT("47mm","27mm","10mm","7mm",1);// 初次颁发
		LODOP.ADD_PRINT_LINE("49mm", "22mm", "46mm", "24mm", 0, 1);
		LODOP.ADD_PRINT_LINE("46mm", "20mm", "49mm", "22mm", 0, 1);
	}

	LODOP.ADD_PRINT_TEXT("45mm", "67mm", "10mm", "7mm", params.workAge); //"岗龄"
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);

	LODOP.ADD_PRINT_TEXT("72.9mm", "47mm", "50mm", "7mm", params.operationCertificateNumber); // 操作证编号
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
	// 打印预览
	LODOP.PREVIEW();
	//PRINT_SETUP打印维护
	// PRINT直接打印
	//LODOP.PRINT();   
	// PRINT_DESIGN打印设计

}
/**
 * 打印操作证书 - 正本
 * @param {Object} params
 */
export function printCertificateZhengben(params) {
	console.log(params)
	let LODOP = getLodop();

	// 获取默认打印机
	LODOP.SET_PRINTER_INDEX(-1);

	// 打印初始化
	LODOP.PRINT_INIT("打印操作证书-正本");
	LODOP.SET_PRINT_PAGESIZE(1, "88mm", "61mm", ""); //设置纸张高度
	LODOP.SET_SHOW_MODE("BKIMG_WIDTH", "88mm");
	LODOP.SET_SHOW_MODE("BKIMG_HEIGHT", "61mm");




	// 有效起止日期：开始
	var validDateStartArr = [];
	var validDateStart = params.validDateStart;
	if (validDateStart != undefined && validDateStart != '') {
		validDateStartArr = validDateStart.split("-");
		var year = validDateStartArr[0];
		validDateStartArr[0] = year.substr(2, 2);
	} else {
		validDateStartArr.push("-");
		validDateStartArr.push("-");
		validDateStartArr.push("-");
	}

	// 有效起止日期：截止
	var validDateEndArr = [];
	var validDateEnd = params.validDateEnd;
	if (validDateEnd != undefined && validDateEnd != '') {
		validDateEndArr = validDateEnd.split("-");
		var year = validDateEndArr[0];
		validDateEndArr[0] = year.substr(2, 2);
	} else {
		validDateEndArr.push("-");
		validDateEndArr.push("-");
		validDateEndArr.push("-");
	}


	/* 
	LODOP.ADD_PRINT_TEXT("86mm","157mm","10mm","7mm",auditTimeStrArr[1]);//"月"
	
	 */

	LODOP.ADD_PRINT_TEXT("17mm", "24mm", "50mm", "7mm", params.operationCertificateNumber); // 操作证编号
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
	LODOP.ADD_PRINT_TEXT("23mm", "24mm", "50mm", "7mm", params.ownerName); // 姓名
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
	LODOP.ADD_PRINT_TEXT("29mm", "24mm", "50mm", "7mm", params.ownerIdentityCards); // 身份证号
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
	LODOP.ADD_PRINT_TEXT("34mm", "24mm", "50mm", "7mm", params.operationItems); // 操作项目
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
	LODOP.ADD_PRINT_TEXT("40mm", "25mm", "10mm", "7mm", validDateStartArr[0]); //"年"  使用期限
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
	LODOP.ADD_PRINT_TEXT("40mm", "33mm", "10mm", "7mm", validDateStartArr[1]); //"月"
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
	LODOP.ADD_PRINT_TEXT("40mm", "41mm", "10mm", "7mm", validDateStartArr[2]); //"日"
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
	LODOP.ADD_PRINT_TEXT("40mm", "54mm", "10mm", "7mm", validDateEndArr[0]); //"年"
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
	LODOP.ADD_PRINT_TEXT("40mm", "62mm", "10mm", "7mm", validDateEndArr[1]); //"月"
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
	LODOP.ADD_PRINT_TEXT("40mm", "69.5mm", "10mm", "7mm", validDateEndArr[2]); //"日"
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);

	if (params.isFirst != undefined && params.isFirst == 2) {
		//LODOP.ADD_PRINT_TEXT("47mm","50mm","10mm","7mm",1);// 换发
		// LODOP.ADD_PRINT_LINE("49mm", "46mm", "46mm", "48mm", 0, 1);
		// LODOP.ADD_PRINT_LINE("46mm", "44mm", "49mm", "46mm", 0, 1);
		LODOP.ADD_PRINT_LINE("49mm", "50mm", "46mm", "52mm", 0, 1);
		LODOP.ADD_PRINT_LINE("46mm", "48mm", "49mm", "50mm", 0, 1);
	} else {
		//LODOP.ADD_PRINT_TEXT("47mm","27mm","10mm","7mm",1);// 初次颁发
		LODOP.ADD_PRINT_LINE("49mm", "22mm", "46mm", "24mm", 0, 1);
		LODOP.ADD_PRINT_LINE("46mm", "20mm", "49mm", "22mm", 0, 1);
	}

	LODOP.ADD_PRINT_TEXT("46mm", "67mm", "10mm", "7mm", params.workAge); //"岗龄"
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);

	// 打印预览
	LODOP.PREVIEW();
	//PRINT_SETUP打印维护
	// PRINT直接打印
	//LODOP.PRINT();   
	// PRINT_DESIGN打印设计

}

/**
 * 打印操作证书 - 副本
 * @param {Object} params
 */
export function printCertificateFuben(params) {

	let LODOP = getLodop();

	// 获取默认打印机
	LODOP.SET_PRINTER_INDEX(-1);

	// 打印初始化
	LODOP.PRINT_INIT("打印操作证书-副本");
	LODOP.SET_PRINT_PAGESIZE(1, "88mm", "61mm", ""); //设置纸张高度
	LODOP.SET_SHOW_MODE("BKIMG_WIDTH", "88mm");
	LODOP.SET_SHOW_MODE("BKIMG_HEIGHT", "61mm");


	LODOP.ADD_PRINT_TEXT("11.9mm", "47mm", "50mm", "7mm", params.operationCertificateNumber); // 操作证编号
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);


	// 打印预览
	LODOP.PREVIEW();
	//PRINT_SETUP打印维护
	// PRINT直接打印
	//LODOP.PRINT();   
	// PRINT_DESIGN打印设计

}



/**
 * 打印操作证书 - 个人证件照片 
 * @param {Object} params
 */
export function printPersonCertificate(params) {
	console.log(params,222)
	let LODOP = getLodop();

	// 获取默认打印机
	LODOP.SET_PRINTER_INDEX(-1);

	// 打印初始化
	LODOP.PRINT_INIT("打印任务名");

	// 设定纸张大小
	LODOP.SET_PRINT_PAGESIZE(1, 1520, 1020, "")

	//LODOP.ADD_PRINT_SETUP_BKIMG("C:\\Users\\Administrator\\Desktop\\证书22.jpg");
	// LODOP.ADD_PRINT_TEXT(104,172,100,20,"操作证编号");
	// 图片
	var arr = params.pics;
	var nameArr = params.names;
	/* for(var i=1;i<=9;i++){
		arr.push("http://www.c-lodop.com/demolist/PrintSample8.jpg");
	} */

	var total = arr.length;
	var limit = 3;
	var rows = Math.floor(total / limit);
	var ys = total % limit;

	if (ys > 0) {
		rows = rows + 1;
	}

	// console.log('total='+total);
	// console.log('limit='+limit);
	// console.log('rows='+rows);
	// console.log('ys='+ys); 

	// 整数或字符型，整数时缺省长度单位为px。
	// 字符型时可包含单位名：in(英寸)、cm(厘米) 、mm(毫米) 、pt(磅)、px(1/96英寸) 、%(百分比)，如“10mm”表示10毫米。
	var intTop = 1.5; //mm
	var intLeft = 5.75; //mm
	var width = 22; //mm
	var height = 32; //mm

	var width2 = 17; //mm
	var height2 = 24; //mm

	// 图片的索引从0开始
	var j = 0;
	for (var i = 1; i <= rows; i++) {
		// intTop,intLeft,intWidth,intHeight
		var intTopi = intTop + height * (i - 1) + 1.5 * (i - 1);

		if (j < total) {
			// 大图
			//LODOP.ADD_PRINT_IMAGE(intTopi,intLeft,width,height,"<img border='0' src='http://www.c-lodop.com/demolist/PrintSample8.jpg' />");
			LODOP.ADD_PRINT_IMAGE(intTopi + "mm", intLeft + "mm", width + "mm", height + "mm", "<img border='0' src='" + arr[j] + "' />");
			//LODOP.SET_PRINT_STYLEA(0,"Stretch",2);//按原图比例(不变形)缩放模式
			LODOP.SET_PRINT_STYLEA(0, "Stretch", 1); //(可变形)扩展缩放模式

			// 小图
			LODOP.ADD_PRINT_IMAGE((intTopi + 8) + "mm", (intLeft + width + 4) + "mm", width2 + "mm", height2 + "mm", "<img border='0' src='" + arr[j] + "' />");
			//LODOP.SET_PRINT_STYLEA(0,"Stretch",2);//按原图比例(不变形)缩放模式
			LODOP.SET_PRINT_STYLEA(0, "Stretch", 1); //(可变形)扩展缩放模式

			// 小图上方添加人员名称
			LODOP.ADD_PRINT_TEXT((intTopi + 1) + "mm", (intLeft + width + 5) + "mm", width2 + "mm", 3 + "mm", nameArr[j]);
			LODOP.SET_PRINT_STYLEA(0, "FontSize", 13);

			j = j + 1;
		}
		if (j < total) {
			// 大图
			LODOP.ADD_PRINT_IMAGE(intTopi + "mm", (intLeft + width + 4 + width2 + 5.75) + "mm", width + "mm", height + "mm", "<img border='0' src='" + arr[j] + "' />");
			//LODOP.SET_PRINT_STYLEA(0,"Stretch",2);//按原图比例(不变形)缩放模式
			LODOP.SET_PRINT_STYLEA(0, "Stretch", 1); //(可变形)扩展缩放模式

			// 小图
			LODOP.ADD_PRINT_IMAGE((intTopi + 8) + "mm", (intLeft + width + 4 + width2 + 5.75 + width + 4) + "mm", width2 + "mm", height2 + "mm", "<img border='0' src='" + arr[j] + "' />");
			//LODOP.SET_PRINT_STYLEA(0,"Stretch",2);//按原图比例(不变形)缩放模式
			LODOP.SET_PRINT_STYLEA(0, "Stretch", 1); //(可变形)扩展缩放模式

			// 小图上方添加人员名称
			LODOP.ADD_PRINT_TEXT((intTopi + 1) + "mm", (intLeft + width + 4 + width2 + 5.75 + width + 5) + "mm", width2 + "mm", 3 + "mm", nameArr[j]);
			LODOP.SET_PRINT_STYLEA(0, "FontSize", 13);

			j = j + 1;
		}
		if (j < total) {
			// 大图
			LODOP.ADD_PRINT_IMAGE(intTopi + "mm", (intLeft + (width + 4 + width2 + 5.75) * 2) + "mm", width + "mm", height + "mm", "<img border='0' src='" + arr[j] + "' />");
			//LODOP.SET_PRINT_STYLEA(0,"Stretch",2);//按原图比例(不变形)缩放模式
			LODOP.SET_PRINT_STYLEA(0, "Stretch", 1); //(可变形)扩展缩放模式

			// 小图
			LODOP.ADD_PRINT_IMAGE((intTopi + 8) + "mm", (intLeft + (width + 4 + width2 + 5.75) * 2 + width + 4) + "mm", width2 + "mm", height2 + "mm", "<img border='0' src='" + arr[j] + "' />");
			//LODOP.SET_PRINT_STYLEA(0,"Stretch",2);//按原图比例(不变形)缩放模式
			LODOP.SET_PRINT_STYLEA(0, "Stretch", 1); //(可变形)扩展缩放模式

			// 小图上方添加人员名称
			LODOP.ADD_PRINT_TEXT((intTopi + 1) + "mm", (intLeft + (width + 4 + width2 + 5.75) * 2 + width + 5) + "mm", width2 + "mm", 3 + "mm", nameArr[j]);
			LODOP.SET_PRINT_STYLEA(0, "FontSize", 13);

			j = j + 1;
		}
	}



	// 打印预览
	LODOP.PREVIEW();
	//PRINT_SETUP打印维护
	// PRINT直接打印
	//LODOP.PRINT();   
	// PRINT_DESIGN打印设计


}
/**
 * 分支设备档案打印
 * @param {Object} params
 */
export function copyPrintFileLicense(params) {
	console.log(params)
	var params = params;
	if (params.areaName.length > 0) {
		let bottomAddress = params.areaName.split('/')
		params.bottomAddress = bottomAddress[1] + '工程机械信息采集单位'
	}
	console.log(params)
	let LODOP = getLodop();
	// 获取默认打印机    
	LODOP.SET_PRINTER_INDEX(-1);


	// 打印初始化
	LODOP.PRINT_INIT("打印任务名");
	LODOP.SET_PRINT_PAGESIZE(1, "210mm", "144mm", ""); //设置纸张高度


	/* LODOP.PRINT_INIT("套打EMS的模板");
	LODOP.ADD_PRINT_TEXT("17.73mm","57.15mm","26.46mm","6.61mm","学生");
	LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
	LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
	LODOP.ADD_PRINT_TEXT("10.85mm","116.42mm","26.46mm","5.29mm","新加文本2");
	LODOP.SET_PRINT_STYLEA(0,"FontName","仿宋");
	LODOP.SET_PRINT_STYLEA(0,"FontSize",10); */



	//LODOP.ADD_PRINT_SETUP_BKIMG("C:\\Users\\Administrator\\Desktop\\牌照3333.JPG");
	LODOP.SET_SHOW_MODE("BKIMG_WIDTH", "210mm");
	LODOP.SET_SHOW_MODE("BKIMG_HEIGHT", "144mm");
	LODOP.ADD_PRINT_TEXT("23mm", "50mm", "60mm", "7mm", params.ownerName);
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
	LODOP.ADD_PRINT_TEXT("33mm", "50mm", "60mm", "7mm", params.equipmentCode);
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
	LODOP.ADD_PRINT_TEXT("43mm", "50mm", "50mm", "7mm", params.emissionRegistration);
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
	LODOP.ADD_PRINT_TEXT("53mm", "50mm", "50mm", "7mm", params.machineryBrand);
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
	LODOP.ADD_PRINT_TEXT("63mm", "50mm", "50mm", "7mm", params.machineryType);
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
	LODOP.ADD_PRINT_TEXT("73mm", "50mm", "50mm", "7mm", params.frameNo);
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
	LODOP.ADD_PRINT_TEXT("83mm", "50mm", "50mm", "7mm", params.engineNumber);
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
	LODOP.ADD_PRINT_TEXT("93mm", "50mm", "50mm", "7mm", params.productionDateStr); //出厂日期
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
	LODOP.ADD_PRINT_TEXT("23mm", "138mm", "50mm", "7mm", params.ownerIdentityCards); // "证件号码"
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
	LODOP.ADD_PRINT_TEXT("33mm", "138mm", "50mm", "7mm", params.environmentalProtectionNumber); //环保编号
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
	LODOP.ADD_PRINT_TEXT("43mm", "138mm", "50mm", "7mm", params.enginePower); //发动机功率
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
	LODOP.ADD_PRINT_TEXT("53mm", "138mm", "50mm", "7mm", params.machineryColor); //机械颜色
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
	LODOP.ADD_PRINT_TEXT("63mm", "138mm", "50mm", "7mm", params.productionCountry); //生产国别
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
	LODOP.ADD_PRINT_TEXT("73mm", "138mm", "50mm", "7mm", params.fuelType); //燃油类型
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
	LODOP.ADD_PRINT_TEXT("83mm", "138mm", "50mm", "7mm", params.overallQuality);
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
	LODOP.ADD_PRINT_TEXT("93mm", "138mm", "50mm", "7mm", params.nuclearInformation); //荷载质量
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
	LODOP.ADD_PRINT_TEXT("103mm", "151mm", "40mm", "7mm", params.bottomAddress); //底部新增XXX市采集单位
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
	//LODOP.ADD_PRINT_TEXT(456,230,217,20,"过户信息");
	//LODOP.ADD_PRINT_TEXT(457,508,155,20,"登记部门");
	LODOP.ADD_PRINT_TEXT("125mm", "151mm", "40mm", "7mm", params.auditTimeStr); //"登记日期"
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);

	/* LODOP.ADD_PRINT_IMAGE(600,237,301,450,"<img border='0' src='"+params.mechanicalPictures2+"' />");
	LODOP.SET_PRINT_STYLEA(0,"Stretch",2);//按原图比例(不变形)缩放模式 */


	// 打印预览
	LODOP.PREVIEW();
	//PRINT_SETUP打印维护
	// PRINT直接打印
	//LODOP.PRINT();   
	// PRINT_DESIGN打印设计
}

/**
 * 打印牌照
 * @param {Object} params
 */
export function printLicense(params) {
	console.log(params)

	var params = params;
	if (params.areaName.length > 0) {
		let bottomAddress = params.areaName.split('/')
		params.bottomAddress = bottomAddress[1] + '工程机械信息采集单位'
	}

	let LODOP = getLodop();
	// 获取默认打印机
	LODOP.SET_PRINTER_INDEX(-1);


	// 打印初始化
	LODOP.PRINT_INIT("打印任务名");
	LODOP.SET_PRINT_PAGESIZE(1, "210mm", "144mm", ""); //设置纸张高度


	/* LODOP.PRINT_INIT("套打EMS的模板");
	LODOP.ADD_PRINT_TEXT("17.73mm","57.15mm","26.46mm","6.61mm","学生");
	LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
	LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
	LODOP.ADD_PRINT_TEXT("10.85mm","116.42mm","26.46mm","5.29mm","新加文本2");
	LODOP.SET_PRINT_STYLEA(0,"FontName","仿宋");  
	LODOP.SET_PRINT_STYLEA(0,"FontSize",10); */



	//LODOP.ADD_PRINT_SETUP_BKIMG("C:\\Users\\Administrator\\Desktop\\牌照3333.JPG");
	LODOP.SET_SHOW_MODE("BKIMG_WIDTH", "210mm");
	LODOP.SET_SHOW_MODE("BKIMG_HEIGHT", "144mm");
	LODOP.ADD_PRINT_TEXT("23mm", "50mm", "60mm", "7mm", params.ownerName);
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
	LODOP.ADD_PRINT_TEXT("33mm", "50mm", "50mm", "7mm", params.equipmentCode);
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
	LODOP.ADD_PRINT_TEXT("43mm", "50mm", "50mm", "7mm", params.emissionRegistration);
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
	LODOP.ADD_PRINT_TEXT("53mm", "50mm", "50mm", "7mm", params.machineryBrand);
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
	LODOP.ADD_PRINT_TEXT("63mm", "50mm", "50mm", "7mm", params.machineryType);
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
	LODOP.ADD_PRINT_TEXT("73mm", "50mm", "50mm", "7mm", params.frameNo);
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
	LODOP.ADD_PRINT_TEXT("83mm", "50mm", "50mm", "7mm", params.engineNumber);
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
	LODOP.ADD_PRINT_TEXT("93mm", "50mm", "50mm", "7mm", params.productionDateStr); //出厂日期
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
	LODOP.ADD_PRINT_TEXT("23mm", "138mm", "50mm", "7mm", params.ownerIdentityCards); // "证件号码"
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
	LODOP.ADD_PRINT_TEXT("33mm", "138mm", "50mm", "7mm", params.environmentalProtectionNumber); //环保编号
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
	LODOP.ADD_PRINT_TEXT("43mm", "138mm", "50mm", "7mm", params.enginePower); //发动机功率
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
	LODOP.ADD_PRINT_TEXT("53mm", "138mm", "50mm", "7mm", params.machineryColor); //机械颜色
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
	LODOP.ADD_PRINT_TEXT("63mm", "138mm", "50mm", "7mm", params.productionCountry); //生产国别
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
	LODOP.ADD_PRINT_TEXT("73mm", "138mm", "50mm", "7mm", params.fuelType); //燃油类型
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
	LODOP.ADD_PRINT_TEXT("83mm", "138mm", "50mm", "7mm", params.overallQuality);
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
	LODOP.ADD_PRINT_TEXT("93mm", "138mm", "50mm", "7mm", params.nuclearInformation); //荷载质量
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
	LODOP.ADD_PRINT_TEXT("103mm", "151mm", "40mm", "7mm", params.bottomAddress); //底部新增XXX市采集单位
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
	//LODOP.ADD_PRINT_TEXT(456,230,217,20,"过户信息");
	//LODOP.ADD_PRINT_TEXT(457,508,155,20,"登记部门");
	LODOP.ADD_PRINT_TEXT("126mm", "151mm", "40mm", "7mm", params.auditTimeStr); //"登记日期"
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);

	/* LODOP.ADD_PRINT_IMAGE(600,237,301,450,"<img border='0' src='"+params.mechanicalPictures2+"' />");
	LODOP.SET_PRINT_STYLEA(0,"Stretch",2);//按原图比例(不变形)缩放模式 */


	// 打印预览
	LODOP.PREVIEW();
	//PRINT_SETUP打印维护
	// PRINT直接打印
	//LODOP.PRINT();   
	// PRINT_DESIGN打印设计

}

/**
 * 打印牌照 - 设备登记证正副本
 * @param {Object} params
 */
export function printLicenseZhengFuBen(params) {
	console.log(params)

	let LODOP = getLodop();

	// 获取默认打印机
	LODOP.SET_PRINTER_INDEX(-1);

	// 出厂日期
	var productionDateStrArr = [];
	var productionDateStr = params.productionDateStr;
	if (productionDateStr != undefined && productionDateStr != '') {
		productionDateStrArr = productionDateStr.split("-");
	} else {
		productionDateStrArr.push("-");
		productionDateStrArr.push("-");
		productionDateStrArr.push("-");
	}

	// mm
	LODOP.PRINT_INIT("打印牌照-设备登记证-正副本");
	LODOP.SET_PRINT_PAGESIZE(1, "88mm", "122mm", ""); //设置纸张高度
	//LODOP.ADD_PRINT_SETUP_BKIMG("C:\\Users\\Administrator\\Desktop\\扫描图\\正本2.png");
	LODOP.SET_SHOW_MODE("BKIMG_WIDTH", "88mm");
	LODOP.SET_SHOW_MODE("BKIMG_HEIGHT", "122mm");

	LODOP.ADD_PRINT_TEXT("20mm", "23mm", "50mm", "7mm", params.equipmentCode); // "设备编号"
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
	LODOP.ADD_PRINT_TEXT("20mm", "60mm", "25mm", "7mm", params.machineryType); // "机械类型"
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
	LODOP.ADD_PRINT_TEXT("25mm", "23mm", "50mm", "7mm", params.ownerName); // "姓名"
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
	LODOP.ADD_PRINT_TEXT("30.5mm", "23mm", "50mm", "7mm", params.engineNumber); // "发动机号"
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
	LODOP.ADD_PRINT_TEXT("30.5mm", "60mm", "25mm", "7mm", params.frameNo); // "整机架号"    SEM00050LS5C28165
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
	LODOP.ADD_PRINT_TEXT("36mm", "37mm", "50mm", "7mm", params.environmentalProtectionNumber); // "环保编号"
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
	LODOP.ADD_PRINT_TEXT("40.5mm", "40mm", "20mm", "7mm", productionDateStrArr[0]); // "年" - 出厂日期
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
	LODOP.ADD_PRINT_TEXT("40.5mm", "57mm", "10mm", "7mm", productionDateStrArr[1]); // "月" - 出厂日期
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
	LODOP.ADD_PRINT_TEXT("40.5mm", "69mm", "10mm", "7mm", productionDateStrArr[2]); // "日" - 出厂日期
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
	// LODOP.ADD_PRINT_TEXT("43.4mm", "40mm", "50mm", "7mm", params.machineryBrand); // "生产厂家" -》 机械品牌
	LODOP.ADD_PRINT_TEXT("45.4mm", "37mm", "48mm", "7mm", params.factory); // "生产厂家" -》 机械品牌   斗山工程机械（中国）有限公
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
	LODOP.ADD_PRINT_TEXT("51mm", "37mm", "50mm", "7mm", params.auditTimeStr); // "发证日期"
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);

	LODOP.ADD_PRINT_TEXT("82mm", "24mm", "40mm", "7mm", params.equipmentCode); // "设备编号"
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
	LODOP.ADD_PRINT_TEXT("82mm", "60mm", "25mm", "7mm", params.machineryType); // "机械类型"
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
	LODOP.ADD_PRINT_TEXT("90mm", "24mm", "40mm", "7mm", params.environmentalProtectionNumber); // "环保编号"
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
	LODOP.ADD_PRINT_TEXT("90mm", "63mm", "40mm", "7mm", params.machineryColor); // "机械颜色"
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);

	// 打印预览
	LODOP.PREVIEW();
	//PRINT_SETUP打印维护
	// PRINT直接打印
	//LODOP.PRINT();   
	// PRINT_DESIGN打印设计

}
/**
 * 打印牌照 - 设备登记证 - 正本
 * @param {Object} params
 */
export function printLicenseZhengBen(params) {
	console.log(params)

	let LODOP = getLodop();

	// 获取默认打印机
	LODOP.SET_PRINTER_INDEX(-1);

	// 出厂日期
	var productionDateStrArr = [];
	var productionDateStr = params.productionDateStr;
	if (productionDateStr != undefined && productionDateStr != '') {
		productionDateStrArr = productionDateStr.split("-");
	} else {
		productionDateStrArr.push("-");
		productionDateStrArr.push("-");
		productionDateStrArr.push("-");
	}

	// mm
	LODOP.PRINT_INIT("打印牌照-设备登记证-正本");
	LODOP.SET_PRINT_PAGESIZE(1, "88mm", "64mm", ""); //设置纸张高度
	//LODOP.ADD_PRINT_SETUP_BKIMG("C:\\Users\\Administrator\\Desktop\\扫描图\\正本2.png");
	LODOP.SET_SHOW_MODE("BKIMG_WIDTH", "88mm");
	LODOP.SET_SHOW_MODE("BKIMG_HEIGHT", "64mm");

	LODOP.ADD_PRINT_TEXT("17mm", "23mm", "50mm", "7mm", params.equipmentCode); // "设备编号"
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
	LODOP.ADD_PRINT_TEXT("17mm", "60mm", "25mm", "7mm", params.machineryType); // "机械类型"
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
	LODOP.ADD_PRINT_TEXT("22mm", "23mm", "50mm", "7mm", params.ownerName); // "姓名"
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
	LODOP.ADD_PRINT_TEXT("27.5mm", "23mm", "50mm", "7mm", params.engineNumber); // "发动机号"
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
	LODOP.ADD_PRINT_TEXT("27.5mm", "60mm", "25mm", "7mm", params.frameNo); // "整机架号"    SEM00050LS5C28165
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
	LODOP.ADD_PRINT_TEXT("33mm", "37mm", "50mm", "7mm", params.environmentalProtectionNumber); // "环保编号"
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
	LODOP.ADD_PRINT_TEXT("38.5mm", "40mm", "20mm", "7mm", productionDateStrArr[0]); // "年" - 出厂日期
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
	LODOP.ADD_PRINT_TEXT("38.5mm", "57mm", "10mm", "7mm", productionDateStrArr[1]); // "月" - 出厂日期
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
	LODOP.ADD_PRINT_TEXT("38.5mm", "69mm", "10mm", "7mm", productionDateStrArr[2]); // "日" - 出厂日期
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
	// LODOP.ADD_PRINT_TEXT("43.4mm", "40mm", "50mm", "7mm", params.machineryBrand); // "生产厂家" -》 机械品牌
	LODOP.ADD_PRINT_TEXT("43.4mm", "37mm", "48mm", "7mm", params.factory); // "生产厂家" -》 机械品牌   斗山工程机械（中国）有限公
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
	LODOP.ADD_PRINT_TEXT("49mm", "37mm", "50mm", "7mm", params.auditTimeStr); // "发证日期"
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);


	// 打印预览
	LODOP.PREVIEW();
	//PRINT_SETUP打印维护
	// PRINT直接打印
	//LODOP.PRINT();   
	// PRINT_DESIGN打印设计

}

/**
 * 打印牌照 - 设备登记证 - 副本
 * @param {Object} params
 */
export function printLicenseFuBen(params) {

	let LODOP = getLodop();

	// 获取默认打印机
	LODOP.SET_PRINTER_INDEX(-1);

	// 单位：mm
	LODOP.PRINT_INIT("打印牌照-设备登记证-副本");
	LODOP.SET_PRINT_PAGESIZE(1, "88mm", "61mm", ""); //设置纸张高度
	//LODOP.ADD_PRINT_SETUP_BKIMG("C:\\Users\\Administrator\\Desktop\\扫描图\\副本2.png");
	LODOP.SET_SHOW_MODE("BKIMG_WIDTH", "88mm");
	LODOP.SET_SHOW_MODE("BKIMG_HEIGHT", "61mm");

	LODOP.ADD_PRINT_TEXT("21mm", "24mm", "40mm", "7mm", params.equipmentCode); // "设备编号"
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
	LODOP.ADD_PRINT_TEXT("21mm", "60mm", "25mm", "7mm", params.machineryType); // "机械类型"
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
	LODOP.ADD_PRINT_TEXT("29mm", "24mm", "40mm", "7mm", params.environmentalProtectionNumber); // "环保编号"
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
	LODOP.ADD_PRINT_TEXT("29mm", "63mm", "40mm", "7mm", params.machineryColor); // "机械颜色"
	LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);


	// 打印预览
	LODOP.PREVIEW();
	//PRINT_SETUP打印维护
	// PRINT直接打印
	//LODOP.PRINT();   
	// PRINT_DESIGN打印设计

}

/**
 * 打印牌照 - 机械图片
 * @param {Object} params
 */
export function printMechanicalPictures(params) {
	let LODOP = getLodop();

	// 获取默认打印机
	LODOP.SET_PRINTER_INDEX(-1);

	// 打印初始化
	LODOP.PRINT_INIT("打印牌照-机械图片");

	// 设定纸张大小
	//LODOP.SET_PRINT_PAGESIZE(1,1520,1020,"")
	LODOP.SET_PRINT_PAGESIZE(1, "152mm", "102mm", ""); //设置纸张高度

	//LODOP.ADD_PRINT_SETUP_BKIMG("C:\\Users\\Administrator\\Desktop\\证书22.jpg");
	LODOP.SET_SHOW_MODE("BKIMG_WIDTH", "152mm");
	LODOP.SET_SHOW_MODE("BKIMG_HEIGHT", "102mm");

	// 图片
	var arr = params.pics;
	// 牌照号
	var numberArr = params.numbers;
	/* for(var i=1;i<=9;i++){
		arr.push("http://www.c-lodop.com/demolist/PrintSample8.jpg");
	} */

	var total = arr.length;
	var limit = 2;
	var rows = Math.floor(total / limit);
	var ys = total % limit;

	if (ys > 0) {
		rows = rows + 1;
	}

	/* console.log('total='+total);
	console.log('limit='+limit);
	console.log('rows='+rows);
	console.log('ys='+ys); */

	// 整数或字符型，整数时缺省长度单位为px。
	// 字符型时可包含单位名：in(英寸)、cm(厘米) 、mm(毫米) 、pt(磅)、px(1/96英寸) 、%(百分比)，如“10mm”表示10毫米。
	var intTop = 2; //mm
	var intLeft = 2; //mm
	var width = 72; //mm
	var height = 98; //mm

	// 图片的索引从0开始
	var j = 0;
	for (var i = 1; i <= rows; i++) {
		var intTopi = intTop + height * (i - 1);

		if (j < total) {
			LODOP.ADD_PRINT_IMAGE(intTopi + "mm", intLeft + "mm", width + "mm", height + "mm", "<img border='0' src='" + arr[j] + "' />");
			//LODOP.SET_PRINT_STYLEA(0,"Stretch",2);//按原图比例(不变形)缩放模式
			LODOP.SET_PRINT_STYLEA(0, "Stretch", 1); //(可变形)扩展缩放模式

			LODOP.ADD_PRINT_TEXT((intTopi + 2) + "mm", (intLeft + 10) + "mm", 200 + "mm", 4 + "mm", numberArr[j]);
			LODOP.SET_PRINT_STYLEA(0, "FontSize", 13);
			LODOP.SET_PRINT_STYLEA(0, "FontColor", "#FF0000"); // 红色

			j = j + 1;
		}
		if (j < total) {
			LODOP.ADD_PRINT_IMAGE(intTopi + "mm", (intLeft + width + 4) + "mm", width + "mm", height + "mm", "<img border='0' src='" + arr[j] + "' />");
			//LODOP.SET_PRINT_STYLEA(0,"Stretch",2);//按原图比例(不变形)缩放模式
			LODOP.SET_PRINT_STYLEA(0, "Stretch", 1); //(可变形)扩展缩放模式

			LODOP.ADD_PRINT_TEXT((intTopi + 2) + "mm", (intLeft + width + 4 + 10) + "mm", 200 + "mm", 4 + "mm", numberArr[j]);
			LODOP.SET_PRINT_STYLEA(0, "FontSize", 13);
			LODOP.SET_PRINT_STYLEA(0, "FontColor", "#FF0000"); // 红色

			j = j + 1;
		}
	}

	// 打印预览
	LODOP.PREVIEW();
	//PRINT_SETUP打印维护
	// PRINT直接打印
	//LODOP.PRINT();   
	// PRINT_DESIGN打印设计
}

/**
 * 打印文档
 * @param {Object} params
 */
export function printFile(params) {

	let LODOP = getLodop();
	// 获取默认打印机
	LODOP.SET_PRINTER_INDEX(-1);

	// 打印初始化
	LODOP.PRINT_INIT("打印任务名");
	// SET_PRINT_PAGESIZE(intOrient,intPageWidth,intPageHeight,strPageName)设定纸张大小
	// ADD_PRINT_TEXT(intTop,intLeft,intWidth,intHeight,strContent)增加纯文本项
	LODOP.ADD_PRINT_TEXT(91, 242, 70, 21, "测试页标题");
	LODOP.ADD_PRINT_TEXT(201, 94, 20, 94, "测试页内容");
	LODOP.ADD_PRINT_TEXT(129, 131, 345, 31, "测试内容一:9号宋体字是默认字体");
	LODOP.ADD_PRINT_TEXT(161, 131, 345, 31, "测试内容二:11号普通宋体字正体");


	// 打印图片  ADD_PRINT_IMAGE和SET_PRINT_STYLEA函数可以缩放打印图片
	LODOP.ADD_PRINT_IMAGE(200, 150, 400, 400, "<img border='0' src='http://www.c-lodop.com/demolist/PrintSample8.jpg' />");
	LODOP.SET_PRINT_STYLEA(0, "Stretch", 2); //按原图比例(不变形)缩放模式

	// 打印预览
	LODOP.PREVIEW();
	//PRINT_SETUP打印维护
	// PRINT直接打印
	// LODOP.PRINT();   
	// PRINT_DESIGN打印设计

}